import { useEffect, useState } from "react";
import axios from 'axios';
import { useDispatch } from "react-redux";

const useFetch =(url)=>{
    const [data,setData] = useState([]);
    const dispatch = useDispatch();
    useEffect(()=>{
        const getData = async()=>{
            dispatch({type:'LOADING',payload:true})
            const fetchData = await axios.get(url);
            setData(fetchData.data.results||fetchData.data);
            dispatch({type:'LOADING',payload:false});
        }
        try{
            getData();

        }
        catch(err){
            console.log(err);
        }


    },[url,dispatch]);

    return {results:data};
}

export default useFetch;